module.exports = __webpack_public_path__ + "img/kylin.3736c065.png";